export default "__VITE_ASSET__CBcjxsqT__"